import React from "react";
import Box from "@mui/material/Box";
import { TabPanelProps } from "../../../common/components/custom-tab-panel-component/custom-tab-panel-component.props";

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`templates-tab-${index}`}
      aria-labelledby={`templates-tab-${index}`}
      className={`${props.fieldName === "afp-support-tickets" && props?.viewOpen ? 'view-ticket-tab-panel' : ''}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
};

export default CustomTabPanel;
